import { render } from "./AdminCoursePage.vue?vue&type=template&id=6b902c09"
import script from "./AdminCoursePage.vue?vue&type=script&lang=js"
export * from "./AdminCoursePage.vue?vue&type=script&lang=js"

import "./AdminCoursePage.vue?vue&type=style&index=0&id=6b902c09&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__